<template>
  <div class="m-0 dbozone-font bg-shikkadood" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-shikkadood">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -shikkadood`">{{ $t('shikkadood.name') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index">
        <div v-if="index===1">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>
      <div class="d-flex flex-column nav-shikkadood">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -shikkadood`">{{ $t('main-game.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/main/wallet_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-balance') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-wallet') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/betamount_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.bet-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet2') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-bet3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/win_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.win-amount') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-win-amount') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/spin_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.spin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin2') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin3') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-spin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/stop_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.stop') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-stop') }}</span>
      </div>
            <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/minus_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.minus') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-minus') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/plus_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.plus') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-plus') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/autospin_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.autospin') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/menu_btn.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.menu') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-menu') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/turbo_on.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.turbo') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-turbo') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/turbo_off.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.normal-turbo') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-normal-turbo') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/exit_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.quit') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/info_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.pay-info') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-info') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/paytable_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.info-paytable') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-paytable') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/history_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.history') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-history') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/option_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.setting') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-setting') }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img class="mt-3 icon-info" :src="require(`../../assets/ruleGames/shikkadood/close_icon.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{$t('main-game.close') }}</span>
      </div>
      <div class="d-flex p-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.text-close') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-shikkadood',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        'shikkadood.text-rule1',
        '3_5_bonus_20.text-rule2',
        '3_5_bonus_20.text-rule3',
        '3_5_bonus_20.text-rule4',
        '3_5_bonus_20.text-rule5',
        '3_5_bonus_20.text-rule6',
        '3_5_bonus_20.text-rule7',
        '3_5_bonus_20.text-rule8',
        '3_5_bonus_20.text-rule9',
        '3_5_bonus_20.text-rule10',
        '3_5_bonus_20.text-rule11',
        '3_5_bonus_20.text-rule12',
        '3_5_bonus_20.text-rule13',
        '3_5_bonus_20.text-rule14',
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    }
  }
}
</script>

<style>

.bg-shikkadood {
  background: #361E09;
}

.nav-shikkadood {
  background: #E8D4A2;
  border-radius: 10px;
}

.text-title.-shikkadood {
  color: #000;
}

</style>